import { chunk } from 'lodash-es'

import { useAppStore } from '@/store/app'

const DEFAULT_DESKTOP_THRESHOLD = 10
const DEFAULT_MOBILE_THRESHOLD = 6

interface UseChunkedListOptions<T> {
  list: ComputedRef<T[] | undefined>
  desktopThreshold?: number
  mobileThreshold?: number
}

export function useChunkedList<T>(options: UseChunkedListOptions<T>) {
  const { list, desktopThreshold = DEFAULT_DESKTOP_THRESHOLD, mobileThreshold = DEFAULT_MOBILE_THRESHOLD } = options
  const appStore = useAppStore()

  const itemPerRowThreshold = computed(() => (appStore.isMobileScreen ? mobileThreshold : desktopThreshold))
  const chunkSize = computed(() => ((list.value?.length ?? 0) > itemPerRowThreshold.value ? 2 : 1))
  const chunkedList = computed(() => chunk(list.value, chunkSize.value))

  return { chunkSize, chunkedList }
}
